import React, { useEffect, useState } from 'react';

interface YouTubeEmbedProps {
  videoId: string;
  title: string;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
  videoId,
  title,
  width = '100%',
  height = '300',
  style = {},
}) => {
  const [cookieConsent, setCookieConsent] = useState<string | null>(null);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    setCookieConsent(consent);
    // Show video only if consent is explicitly accepted
    setShowVideo(consent === 'accepted');

    const handleCookieConsentAccepted = (event: CustomEvent) => {
      if (event.detail?.accepted) {
        setCookieConsent('accepted');
        setShowVideo(true);
      }
    };

    window.addEventListener(
      'cookieConsentAccepted',
      handleCookieConsentAccepted as EventListener
    );

    return () => {
      window.removeEventListener(
        'cookieConsentAccepted',
        handleCookieConsentAccepted as EventListener
      );
    };
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setCookieConsent('accepted');
    setShowVideo(true);

    const cookieAcceptedEvent = new CustomEvent('cookieConsentAccepted', {
      detail: { accepted: true },
    });
    window.dispatchEvent(cookieAcceptedEvent);
  };

  // Show consent UI if video is not shown (either no consent or rejected)
  if (!showVideo) {
    return (
      <div
        style={{
          width,
          height,
          backgroundColor: '#f5f5f5',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          ...style,
        }}
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h4 style={{ margin: '0 0 12px 0', color: '#333' }}>{title}</h4>
          <p
            style={{
              margin: '0 0 16px 0',
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.5',
            }}
          >
            {cookieConsent === 'rejected'
              ? 'Çerez kullanımını reddettiğiniz için video görüntülenemiyor. Videoyu izlemek için çerezleri kabul edin.'
              : 'Bu video içeriğini görüntülemek için çerez kullanımını kabul etmeniz gerekmektedir.'}
          </p>
          <button
            onClick={handleAcceptCookies}
            style={{
              padding: '8px 16px',
              border: 'none',
              backgroundColor: '#e74c3c',
              color: '#fff',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#c0392b';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#e74c3c';
            }}
          >
            {cookieConsent === 'rejected'
              ? 'Çerezleri Kabul Et'
              : 'Çerezleri Kabul Et ve Videoyu İzle'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <iframe
      width={width}
      height={height}
      src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`}
      title={title}
      frameBorder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      allowFullScreen
      referrerPolicy='strict-origin-when-cross-origin'
      style={style}
      loading='lazy'
    />
  );
};

export default YouTubeEmbed;
